export default __webpack_public_path__ + "static/media/base-report9.3dbea808.png";